import { Card, Col, Container, Row } from "react-bootstrap";
import useStore from "../../../../Zustand/Zustand";
import ZustandFormImovel from "../../../../Zustand/ZustandFormImovel";
import ZustandProductCgi from "../../../../Zustand/ZustandProductCgi";
import formatToReal from "../../../../Utils/fomartToReal";

const SimulationInter = (props) => {
  const { valorDeEntrada, valorDoImovel, prazoMeses, valorFGTS } = ZustandFormImovel();
  const { cgi, prazoMesesCgi, valorEmprestimo } = ZustandProductCgi();

  const simulacao = useStore((state) => state.simulacoes);
  const valorFinanciamento = valorDoImovel - valorDeEntrada;

  if (!simulacao) return null;
  return (
    <Card className="bg-white text-dark" style={{ width: "45rem" }}>
      <Card.Img
        style={{ width: "7rem", padding: "1rem" }}
        variant="top"
        src="./assets/inter.svg"
      />
      <Card.Body>
        {cgi != "CGI" ? (
          <Row>
            <Col>
              <Card.Text
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "400",
                  paddingTop: "0.15rem",
                  paddingBottom: "0.15rem",
                }}
              >
                Valor do financiamento
              </Card.Text>
            </Col>
            <Col>
              <Card.Text
                className="text-end"
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "500",
                  paddingTop: "0.15rem",
                  paddingBottom: "0.15rem",
                }}
              >
                {formatToReal(valorFinanciamento)}
              </Card.Text>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col>
              <Card.Text
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "400",
                  paddingTop: "0.15rem",
                  paddingBottom: "0.15rem",
                }}
              >
                Valor do emprestimo
              </Card.Text>
            </Col>
            <Col>
              <Card.Text
                className="text-end"
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "500",
                  paddingTop: "0.15rem",
                  paddingBottom: "0.15rem",
                }}
              >
                {formatToReal(valorEmprestimo)}
              </Card.Text>
            </Col>
          </Row>
        )}
        {cgi != "CGI" ? (
          <Row>
            <Col>
              <Card.Text
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "400",
                  paddingTop: "0.15rem",
                  paddingBottom: "0.15rem",
                }}
              >
                Valor de entrada / FGTS
              </Card.Text>
            </Col>
            <Col>
              <Card.Text
                className="text-end"
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "500",
                  paddingTop: "0.15rem",
                  paddingBottom: "0.15rem",
                }}
              >
                {formatToReal(valorDeEntrada || 0 + valorFGTS || 0)}
              </Card.Text>
            </Col>
          </Row>
        ) : null}

        {cgi != "CGI" ? (
          <Row>
            <Col>
              <Card.Text
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "400",
                  paddingTop: "0.15rem",
                  paddingBottom: "0.15rem",
                                }}
              >
                Prazo
              </Card.Text>
            </Col>
            <Col>
              <Card.Text
                className="text-end"
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "500",
                  paddingTop: "0.15rem",
                  paddingBottom: "0.15rem",
                }}
              >
                {prazoMeses} meses
              </Card.Text>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col>
              <Card.Text
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "400",
                  paddingTop: "0.15rem",
                  paddingBottom: "0.15rem",            
                    }}
              >
                Prazo
              </Card.Text>
            </Col>
            <Col>
              <Card.Text
                className="text-end"
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "500",
                  paddingTop: "0.15rem",
                  paddingBottom: "0.15rem",
                }}
              >
                {prazoMesesCgi} meses
              </Card.Text>
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            <Card.Text
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "400",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              Primeira parcela
            </Card.Text>
          </Col>
          <Col>
            <Card.Text
              className="text-end"
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              {formatToReal(simulacao[0].valorPrimeiraParcela)}
            </Card.Text>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card.Text
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "400",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              Última parcela
            </Card.Text>
          </Col>
          <Col>
            <Card.Text
              className="text-end"
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              {formatToReal(simulacao[0].valorUltimaParcela)}
            </Card.Text>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card.Text
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "400",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              Sistema de Amortização
            </Card.Text>
          </Col>
          <Col>
            <Card.Text
              className="text-end"
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              {simulacao[0].sistemaAmortizacao}
            </Card.Text>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card.Text
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "400",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              Taxa de juros
            </Card.Text>
          </Col>
          <Col>
            <Card.Text
              className="text-end"
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              {simulacao[0].produto}
            </Card.Text>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card.Text
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "400",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              Custo Efetivo Total (CESH)
            </Card.Text>
          </Col>
          <Col>
            <Card.Text
              className="text-end"
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              {formatToReal(simulacao[0].totalCesh)}
            </Card.Text>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card.Text
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "400",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              Custo Efetivo Total (CET)
            </Card.Text>
          </Col>
          <Col>
            <Card.Text
              className="text-end"
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                paddingTop: "0.15rem",
                paddingBottom: "0.15rem",
              }}
            >
              {formatToReal(simulacao[0].totalCet)}
            </Card.Text>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SimulationInter;
